import React, { useRef, useState, useEffect } from 'react';
import { FaTrophy, FaMedal, FaCertificate, FaAward } from 'react-icons/fa';
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { IoMdRocket } from "react-icons/io";
import { PiCodeThin } from "react-icons/pi";
import { IoMdPerson } from "react-icons/io";

// Import your SIH image
import sih from "../assets/achivements/sih.jpeg";
import ideathon from "../assets/achivements/ideathon.jpg";
import codeathon from "../assets/achivements/codeathon.jpg";
import sih24 from "../assets/achivements/sih24.jpg";
import gfg from "../assets/achivements/gfg.png";
import gdgc from "../assets/achivements/gdgc.jpg";
import hackno from "../assets/hackno.jpg"


// Your achievements array with added background images
const achievements = [
  {
    icon: <FaTrophy />,
    title: "Smart India Hackathon'23 Winner",
    description: "secured first place in the prestigious Smart India Hackathon, organized under the Ministry of Jal Shakti.",
    link: 'https://www.linkedin.com/posts/prince-sharma-047973253_smartindiahackathon-digitalabrdruids-sih2023-activity-7144621869306945536-VaMe?utm_source=share&utm_medium=member_desktop',
    backgroundImage: sih // Using the imported SIH image
  },
  {
    icon: <FaMedal />,
    title: "IDEATHON 2.0 3rd Position",
    description: "secured 3rd place in the Ideathon 2.0 Hackathon at ABESIT, competing among all 2nd-year students.",
    link: 'https://www.linkedin.com/posts/prince-sharma-047973253_reactjs-firebase-developer-activity-7154081852335525888-J5fU/?utm_source=share&utm_medium=member_desktop',
    backgroundImage: ideathon // Replace with your actual image
  },
  {
    icon: <IoMdRocket />,
    title: "ISRO SIH'24 - Top 47 Team",
    description: "Out of thousands of participants, we ranked among the top 47 teams in India for ISRO's problem statements.",
    link: 'https://www.linkedin.com/posts/prince-sharma-047973253_sih2024-techfixer-isro-activity-7277622696543186944-aGt4/?utm_source=share&utm_medium=member_desktop',
    backgroundImage: sih24 // Replace with your actual image
  },
  {
    icon: <FaAward />,
    title: " Core Member - Web Developer @GDGC ABESIT'24",
    description: "I'm proud to be a Core Member of the Web Development team at GDGC ABESIT'24, contributing to innovative projects.",
    link: 'https://www.linkedin.com/posts/prince-sharma-047973253_googledevelopers-gdsc-abesit-activity-7245896128531996672-z9zn?utm_source=share&utm_medium=member_desktop',
    backgroundImage: gdgc // Replace with your actual image
  },
  {
    icon: <PiCodeThin />,
    title: "Code-A-Thon 3.0 2nd Position",
    description: "secured the Consolation Prize in the CSE Department's Code-A-Thon 3.0 during my 3rd year at ABESIT",
    link: 'https://www.linkedin.com/posts/prince-sharma-047973253_codeathon-teamwork-disastermanagement-activity-7278487141259661316-8a7t/?utm_source=share&utm_medium=member_desktop',
    backgroundImage: codeathon // Replace with your actual image
  },
  {
    icon: <IoMdPerson />,
    title: "Tech Lead in hacknovate 6.0",
    description: "Led technical setup, event execution, and partnerships. Actively contribute in Hacknovate 6.0 official website for a seamless user experience",
    link: 'https://www.linkedin.com/posts/prince-sharma-047973253_hacknovate6-techteam-hackathonjourney-activity-7316085944757932032-x_12?utm_source=share&utm_medium=member_desktop&rcm=ACoAAD6c53cBRZ6cLuxGieb3FvPGLWbXCN6UTMs',
    backgroundImage: hackno // Replace with your actual image
  },
  {
    icon: <FaCertificate />,
    title: "300+ DSA Problems Solved on GeeksForGeeks",
    description: "I solved 300+ DSA problems on GeeksForGeeks, improving my problem-solving skills and understanding of algorithms.",
    link: 'https://www.geeksforgeeks.org/user/prince128n7xq/',
    backgroundImage: gfg // Replace with your actual image
  },
  // ... other achievements
];

const Achievements = () => {
  const gridRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const checkScrollPosition = () => {
    if (gridRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = gridRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10); // -10 for small buffer
    }
  };

  useEffect(() => {
    const grid = gridRef.current;
    if (grid) {
      grid.addEventListener('scroll', checkScrollPosition);
      // Check initial state
      checkScrollPosition();
    }
    return () => {
      if (grid) {
        grid.removeEventListener('scroll', checkScrollPosition);
      }
    };
  }, []);

  const scrollRight = () => {
    if (gridRef.current) {
      const scrollAmount = gridRef.current.clientWidth;
      gridRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const scrollLeft = () => {
    if (gridRef.current) {
      const scrollAmount = gridRef.current.clientWidth;
      gridRef.current.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const getCardHoverStyles = (backgroundImage) => ({
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  });

  const getArrowStyles = (show) => ({
    opacity: show ? '1' : '0',
    pointerEvents: show ? 'auto' : 'none',
  });

  return (
    <>
      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      <section className="bg-white py-16 px-8 text-black col-span-12 rounded-3xl overflow-hidden w-96 sm:w-full">
      {/* Section Title with custom underline */}
      <div className="text-center mb-12 relative">
        <h2 className="text-3xl sm:text-4xl font-black text-black mb-2">Top Achievements</h2>
        <div className="w-12 h-1 bg-yellow-400 mx-auto mt-2"></div>
      </div>
      
      <div className="relative px-5">
        {/* Left Arrow */}
        <FaArrowLeft 
          onClick={scrollLeft}
          className="absolute -left-8 text-gray-500 text-2xl top-1/2 transform -translate-y-1/2 z-10 cursor-pointer transition-colors duration-300 hover:text-blue-500"
          style={getArrowStyles(showLeftArrow)}
        />
        
        {/* Achievements Grid */}
        <div 
          ref={gridRef}
          className="grid grid-flow-col auto-cols-[calc(100%-2rem)] sm:auto-cols-[calc(50%-2rem)] md:auto-cols-[calc(33.33%-2rem)] lg:auto-cols-[calc(25%-2rem)] gap-8 overflow-x-auto scroll-smooth pb-5 hide-scrollbar"
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="relative rounded-lg p-6 transition-all duration-300 h-full cursor-pointer flex flex-col min-h-[250px] overflow-hidden border-2 border-gray-400 group hover:-translate-y-1 hover:shadow-xl"
              style={getCardHoverStyles(achievement.backgroundImage)}
            >
              {/* Overlay */}
              <div className="absolute inset-0 bg-white bg-opacity-80 group-hover:bg-opacity-10 transition-all duration-300 z-10"></div>
              
              {/* Card Content */}
              <div className="flex-1 flex flex-col relative z-20">
                <div className="text-2xl sm:text-3xl mb-4 text-yellow-400 relative z-20 transition-colors duration-300 group-hover:text-transparent">
                  {achievement.icon}
                </div>
                <h3 className="text-base sm:text-xl font-black mb-2 text-gray-800 relative z-20 group-hover:text-transparent transition-colors duration-300">
                  {achievement.title}
                </h3>
                <p className="text-xs sm:text-sm opacity-80 mb-4 flex-grow relative z-20 text-gray-800 group-hover:text-transparent transition-colors duration-300">
                  {achievement.description}
                </p>
                <a 
                  href={achievement.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 no-underline font-bold text-xs sm:text-sm mt-auto self-start relative z-20 hover:underline group-hover:text-transparent transition-colors duration-300"
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>
        
        {/* Right Arrow */}
        <FaArrowRight 
          onClick={scrollRight}
          className="absolute -right-8 sm:right-4 text-gray-500 text-2xl top-1/2 transform -translate-y-1/2 z-10 cursor-pointer transition-colors duration-300 hover:text-blue-500"
          style={getArrowStyles(showRightArrow)}
        />
        
        {/* Gradient overlay on right */}
        <div className="absolute right-0 top-0 h-full w-12 bg-gradient-to-r from-transparent to-white pointer-events-none"></div>
      </div>
    </section>
    </>
  );
};

export default Achievements;